import { render, staticRenderFns } from "./LostfoundAdd.vue?vue&type=template&id=4dd283d9&scoped=true"
import script from "./LostfoundAdd.vue?vue&type=script&lang=js"
export * from "./LostfoundAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd283d9",
  null
  
)

export default component.exports